import React, { useState, useEffect } from 'react';
import Lottie from 'react-lottie';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';


const PaymentFailed = () => {
        const navigate = useNavigate();
    
    const [animationData, setAnimationData] = useState(null);

    useEffect(() => {
        // Load the Lottie animation for an exclamation mark
        fetch('/exclamation-animation.json') // Ensure the path is correct for your Lottie animation file
            .then((response) => response.json())
            .then((data) => setAnimationData(data))
            .catch((error) => console.error('Error loading Lottie animation:', error));
    }, []);

    const defaultOptions = {
        loop: true, // Loop the animation for consistent emphasis
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };




    return (
        <div className="payment-failed-container">
            {/* Animated Icon Section */}
            <motion.div
                className="icon-container"
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{
                    duration: 0.8,
                    type: 'spring',
                    stiffness: 100,
                    damping: 12,
                }}
                style={{ position: 'relative' }}
            >
                {/* Lottie Animation */}
                {animationData && (
                    <div className="failure-animation">
                        <Lottie options={defaultOptions} height={120} width={120} />
                    </div>
                )}

                {/* Exclamation Icon */}
                <FontAwesomeIcon
                    icon={faExclamationCircle}
                    size="3x"
                    color="#721c24"
                    style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                    }}
                />
            </motion.div>

            {/* Message Section */}
            <motion.div
                className="message-container"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.3 }}
            >
                <h1>Payment Failed!</h1>
                <p>Unfortunately, your payment could not be processed.</p>
                <p>Please check your payment details or try again later.</p>
            </motion.div>

            {/* Action Button Section */}
            <motion.div
                className="action-container"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.8, delay: 0.5 }}
            >
                <button
                    className="retry-button"
                    onClick={() => navigate('/booking')} 
                >
                    Back to Booking
                </button>
                {/* <button
                    className="contact-button"
                    onClick={() => (window.location.href = '/contact-support')} // Replace with your support page route
                >
                    Contact Support
                </button> */}
            </motion.div>
        </div>
    );
};

export default PaymentFailed;
